import linkIndex from './Links';

export default  {
  body: 'Trinkets',
  title: 'WebTrinkets',
  links: {
    primary: ['home', 'blog', 'trinkets'],
    trinkets: ['classProject', 'hackAThon', 'demoDay'],
  },
  linkIndex,
};
